import React from "react";
import { Br, Text } from "components";
import ctl from "@netlify/classnames-template-literals";
import { MailingListForm } from "./mailing-list-form";

const MailingList = () => {
  return (
    <div className={mailListWrapperStyle}>
      <Text
        variant="h3"
        value={
          <>
            Get Latest updates before
            <Br on="all" />
            they happen
          </>
        }
        color="alternative-800"
      />

      <div>
        <MailingListForm buttonText="Join our newsletter" />
      </div>
    </div>
  );
};

const mailListWrapperStyle = ctl(`
 py-12 
flex
xl:flex-row
gap-8
flex-col
xl:text-left
text-center
justify-between
`);

export { MailingList };
